import { getOccupiedSquareSize } from './gridSpatial';

// Persistence stores the top-left occupied cell's anchor, never the art center.
export function tokenFootprintLayout(token, position, columns, rows) {
  const size = getOccupiedSquareSize(token);
  const x = Math.floor(Number(position?.x || 0) * columns),
    y = Math.floor(Number(position?.y || 0) * rows);
  return {
    size,
    anchor: {
      x,
      y
    },
    center: {
      x: (x + size / 2) / columns,
      y: (y + size / 2) / rows
    },
    width: size / columns,
    height: size / rows
  };
}

// Offset the visible alpha bounding-box center, without cropping or resizing.
// object-fit:contain fits the entire image canvas into a square art box.
export function artworkCenterOffset({
  width,
  height,
  bounds
} = {}) {
  if (!bounds || !(width > 0 && height > 0)) return {
    x: 0,
    y: 0
  };
  const longest = Math.max(width, height);
  return {
    x: 100 * (width / 2 - (bounds.left + bounds.right) / 2) / longest,
    y: 100 * (height / 2 - (bounds.top + bounds.bottom) / 2) / longest
  };
}
export function alphaBounds(data, width, height, threshold = 8) {
  let left = width,
    top = height,
    right = 0,
    bottom = 0;
  for (let y = 0; y < height; y++) for (let x = 0; x < width; x++) if (data[(y * width + x) * 4 + 3] > threshold) {
    left = Math.min(left, x);
    top = Math.min(top, y);
    right = Math.max(right, x + 1);
    bottom = Math.max(bottom, y + 1);
  }
  return right > left && bottom > top ? {
    left,
    top,
    right,
    bottom
  } : null;
}
const cache = new Map();
export function loadArtworkBounds(url) {
  if (cache.has(url)) return cache.get(url);
  const pending = new Promise(resolve => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onerror = () => resolve(null);
    image.onload = () => {
      try {
        const scale = Math.min(1, 512 / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        const context = canvas.getContext('2d', {
          willReadFrequently: true
        });
        if (!context) {
          resolve(null);
          return;
        }
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
        resolve({
          width: canvas.width,
          height: canvas.height,
          bounds: alphaBounds(context.getImageData(0, 0, canvas.width, canvas.height).data, canvas.width, canvas.height)
        });
      } catch (error) {
        resolve(null);
      } // CORS/unsupported canvases retain canvas centering.
    };
    image.src = url;
  });
  if (cache.size >= 128) cache.delete(cache.keys().next().value);
  cache.set(url, pending);
  return pending;
}
